import { useNavigate } from "react-router-dom";
import style from './index.module.css';
import { useState } from "react";
export default function Status({login , setLogin,user, setUser}) {
    const navigate = useNavigate();
   const [state,setState] = useState(false);
   const [stateInfo,SetStateInfo] = useState('Заявление в работе');
   function getRequiredValue(id, label = id) {
        const input = document.getElementById(id);
        if (!input) {
            console.error(`Input #${id} not found`);
            return null;
        }

        input.style.border = '';
        input.style.outline = '';

        const value = input.value.trim();
        if (!value) {
            console.error(`${label} пустой`);
            input.style.border = '1px solid red';
            input.style.outline = 'none';
            input.focus();
            return null;
        }

        return value;
    }
    const SendToServer = async () => {
        const id  = getRequiredValue('id', 'ID');
        if (![id].every(Boolean)) return;
       

        fetch("https://im-gpt.ru:3000/api/checkCharge", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id }),
            })
            .then(res => res.json())
            .then(data => {
                if(data.error) return alert(data.error);
                else{

                    setState(data.id); 
                    switch(data.status)
                    {
                        case 1: 
                            SetStateInfo('Заявление в работе');
                            break;
                        case 2: 
                            SetStateInfo('Отказано в возврате');
                            break;
                        case 3: 
                            SetStateInfo('Возврат средств одобрен');
                            break;
                        default:
                            SetStateInfo('Заявление зарегистрировано');
                            break;
                    }
                }
            })
        .catch(err => console.error(err));
        //setState(true)
   }

  return (
    <div className={style.page}>
         <div className={style.fire1} />
         <div className={style.container}>
                <div className={style.header}>
                    <div className={style.logo} onClick={() => navigate("/")}>I’m-GPT</div>
                    <div className={style.enter} onClick={() => navigate("/chat?login")}>
                        <img src='img/enter.png' alt='Войти'/>
                        <p>{login ? user?.email : 'Войти'}</p>
                    </div>
                </div>
            </div>
            <div className={style.padd10}>
                {!state ? 
                (<div className={style.alertcharge}>
                    <h2>Статус заявки</h2>
                    <h4>Введите ID заявки который Вам был выдан после заполнения</h4>
                    <input type="text" id="id" placeholder="ID"/>
                    <button className={style.btn} onClick={() => SendToServer()}>Проверить</button>
                </div>)
                :
                (<div className={style.alertcharge}>
                    <h2>ID: {state}</h2>
                    <h4>Статус: <span>{stateInfo}</span></h4>
                    <button className={style.btn} onClick={() => navigate("/")}>Закрыть</button>
                    <h5 className={style.mt25}>Заявка обрабатывается до 10 дней, но обычно это занимает 1-3 дня</h5>
                </div>)}
            </div>
    </div>
  );
}
